export default "__VITE_ASSET__wTdokFm$__"